var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"border":"","columns":_vm.fileSchemaList,"data":_vm.attachments},scopedSlots:_vm._u([{key:"action",fn:function({ row }){return [_c('Button',{attrs:{"type":"success","shape":"circle","icon":"md-download"},on:{"click":function($event){return _vm.downloadAttachment(row)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }